<div [ngClass]="variant">
  <ng-content></ng-content>
</div>